// import { createSelector } from 'reselect';

export const getIsPutting = state => state.getIn(['consultationCase', 'isPutting']);
export const getErrMsg = state => state.getIn(['consultationCase', 'errMsg']);

export const getCaseRelateList = state => state.getIn(['consultationCase', 'caseRelateList']);
export const getIsGettingCaseRelated = state => state.getIn(['consultationCase', 'isGettingCaseRelated']);